import { Component, OnInit } from '@angular/core';
import { LogPesquisaService } from '../../services/log-pesquisa.service';
import { MedicamentoService } from '../../services/medicamento.service';
import { AutorizadorService } from '../../services/autorizador.service';
import { ProgramaService } from '../../services/programa.service';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { HistoricoPesquisasMensalService } from 'src/app/services/historicoPesquisasMensal.service';
import { LeadIndicadorService } from 'src/app/services/lead-indicador.service';

@Component({
    selector: 'app-inicio',
    templateUrl: './inicio.component.html',
    styleUrls: ['./inicio.component.css'],
    standalone: false
})
export class InicioComponent implements OnInit {
  dataAtual = new Date();
  loadingQtdPesquisas = true;
  loadingQtdMedicamentos = true;
  loadingTotalLeads = false;
  loadingNovosLeads = false;

  qtdMedicamentos = '';
  qtdPesquisas = 0;
  qtdPesquisasMes = 0;
  qtdTotalLeads = 0;
  qtdNovosLeads = 0;

  isVisibleHistorico = false;
  isVisibleHistoricoTotalLeads = false;
  isVisibleHistoricoNovosLeads = false;
  constructor(
    private logPesquisaService: LogPesquisaService,
    private medicamentoService: MedicamentoService,
    private historicoPesquisasMensalService: HistoricoPesquisasMensalService,
    private leadIndicadorService: LeadIndicadorService
  ) { }

  ngOnInit(): void {
    this.loadingNovosLeads = true;
    this.leadIndicadorService.novosLeads().subscribe((data: any) => {
      this.loadingNovosLeads = false;
      this.qtdNovosLeads = data.data.novos_leads;
    });

    this.loadingTotalLeads = true;
    this.leadIndicadorService.totalLeads().subscribe((data: any) => {
      this.loadingTotalLeads = false;
      this.qtdTotalLeads = data.data.total;
    });

    this.logPesquisaService.qtdPesquisaData().subscribe((l: any) => {
      this.qtdPesquisas = l.data.log_pesquisa;
      this.loadingQtdPesquisas = false;
    });

    this.medicamentoService.all().subscribe((m: any) => {
      this.loadingQtdMedicamentos = false;
      this.qtdMedicamentos = m.data.medicamento.total;
    });

    this.historicoPesquisasMensalService.mesAtual().subscribe((data: any) => {
      this.qtdPesquisasMes = data.data.historico;
    });

  }

  openHistoricoPesquisasMensal(){
    this.isVisibleHistorico = true;
  }

  closeHistorico(){
    this.isVisibleHistorico = false;
  }

  openHistoricoTotalLeads(){
    this.isVisibleHistoricoTotalLeads = true;
  }

  closeHistoricoTotalLeads(){
    this.isVisibleHistoricoTotalLeads = false;
  }

  openHistoricoNovosLeads(){
    this.isVisibleHistoricoNovosLeads = true;
  }

  closeHistoricoNovosLeads(){
    this.isVisibleHistoricoNovosLeads = false;
  }
}

